import { handleize } from '../../js/helpers/handleize';
const listOfBadges = ['personalized', 'exclusive', 'officially licensed', 'push pin'];
const vn = window.vNode;
export const createBadges = (item) => {
    return [
        vn.create('div', { class: 'alg__result-item_flags pos:a l:0 d:flex ai:center' }, listOfBadges.reduce((arr, badge, index) => {
            if (item.labels?.includes(badge) === true) {
                arr.push(vn.create('span', {
                    class: `flag:${handleize(badge)} z:${listOfBadges.length - index} text:uppercase text:nowrap`,
                    'aria-hidden': true
                }, [`${badge}`]));
            }
            return arr;
        }, [])),
        ...(item.labels?.includes('hot deal') === true
            ? [
                vn.create('span', {
                    class: 'flag:hot-deal pos:a z:2 l:0 fw:700 alg__result-item_flags_hot-deal'
                }, ['HOT DEAL'])
            ]
            : [])
    ];
};
